import {Widget} from "base/assets/js/widget/Widget.js";
import {Editor} from "base/assets/js/widget/Editor.js";

/**
 * автосохранение черновика
 */
export class DraftSave extends Widget {

	sId = null;
	bTextChanged = false;
	bSaveBtnClick = false;
	iSuccessTimeout = 0;

	run() {

		// клик по кнопкам предпросмотр или сохранить, автоматически сохраняет черновик
		this._on( 'SaveBtn', 'click', () => {
			this.bSaveBtnClick = true;
		} );

		// сообщение о том что пост не сохранен
		this._on( window, 'beforeunload', ( oEvent ) => {
			if( this.bTextChanged && !this.bSaveBtnClick ) {
				const sMessage = 'Ваши изменения не сохранены. Если вы уйдете со страницы, эти изменеия пропадут.';
				if( typeof oEvent == "undefined" ) {
					oEvent = window.event;
				}
				if( oEvent ) {
					oEvent.returnValue = sMessage;
				}
				return sMessage;
			}
		} );

		this._my( { 'draft-id': 's:sId' } );
		window.setInterval( ::this.draftSave, 10000 );

		const oEditor = this._rel()
			.typeOf( Editor )
			.canEmpty( true )
			.find();
		if( oEditor ) {
			this._on( oEditor.bl(), 'textChange', ::this.onTextChange );
		}
	}

	onTextChange() {
		if( !this.bTextChanged ) {
			this.bTextChanged = true;
			this.message();
		}
	}

	draftSave() {
		if( !this.bTextChanged ) {
			return;
		}
		this.post( '/topic/draftSave?iDraftId=' + this.sId, new FormData( this.bl() ) )
			.then(
				( oResponse ) => {
					this.bTextChanged = false;
					if( this.iSuccessTimeout ) {
						clearInterval( this.iSuccessTimeout );
					}
					this.iSuccessTimeout = setTimeout( () => {
						this.message( oResponse.sMessage, true );
					}, 3000 );
				},
				( { sMessage } ) => {
					this.message( sMessage, false );
				}
			);
	}

	message( sMessage, bSuccess ) {
		this._el( 'Success' ).textContent = '';
		this._el( 'Error' ).textContent = '';
		if( sMessage ) {
			if( bSuccess ) {
				this._el( 'Success' ).textContent = sMessage;
			} else {
				this._el( 'Error' ).textContent = 'Ошибка сохранения черновика: ' + sMessage;
			}
		}
		if( this.iSuccessTimeout ) {
			clearInterval( this.iSuccessTimeout );
		}
	}
}